// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".large-content[data-v-2ca30e7a]{width:1000px!important;margin-left:-250px!important}", ""]);
// Exports
module.exports = exports;
